module.exports = __webpack_public_path__ + "img/menu-link.650c76e9.svg";